import applyValidation, {
  applyInputValidation,
  removeInputValidation
} from '../validation/applyValidation';
import getErrorTag from '../elements/getErrorTag';
import getFields from '../elements/getFields';
import getForm from '../elements/getForm';
import serialize from '../validation/serialize';
import validate from 'validate.js';
import validationRules from '../validation/validationRules';
import * as formWizardConstants from '../elements/constants';
import * as panelModel from './panel';
import * as stepModel from './step';
import 'element-closest-polyfill';

/**
 * Validates the form again, if the field has already been validated
 *
 * @param {Event} event
 */
export const revalidate = event => {
  const { target } = event;
  const form = getForm(target);
  const targetsPanel = stepModel.getStep(target);
  const activePanel = panelModel.getActivePanel(form);

  if (target.classList.contains(formWizardConstants.classes.validatedInput)) {
    // only validate if the target came from the active panel
    if (targetsPanel == activePanel) {
      validateForm(form);
    }
  }
};

/**
 * Validates all visible fields in a form, returning true if there were any validation errors
 *
 * @param {Element} form
 */
export const validateForm = form => {
  const serializedForm = serialize(form);
  const rules = validationRules(form);
  const results = validate(serializedForm, rules);
  applyValidation(form, results || {});
  return !results;
};

/**
 * Validates a given input, returning true if there were not any validation errors
 *
 * @param {Element} input
 */
export const validateInput = input => {
  const type = input.getAttribute('type');
  if (formWizardConstants.datoNonTextInputTypes.includes(type)) {
    return validateNonTextInput(input);
  } else {
    return validateTextInput(input);
  }
};


/**
 * Validates text inputs (e.g. text, email), returning true if no validation errors
 *
 * @param {Element} input
 */
export const validateTextInput = input => {
  const valid = input.checkValidity();
  const field = input.closest(formWizardConstants.selectors.formField);
  const errorTag = getErrorTag(field);
  if (!errorTag) return valid;
  if (!valid) {
    field.classList.add(formWizardConstants.classes.formFieldValidated);
  }
  return valid;
};

/**
 * Validates non text inputs (e.g. checkbox), returning true if there were not any validation errors
 *
 * @param {Element} input
 */
export const validateNonTextInput = input => {
  const valid = input.checkValidity();
  const message = 'Required';
  if (valid) {
    removeInputValidation(input);
  } else {
    applyInputValidation(input, message);
  }
  return valid;
};

/**
 * Validates all inputs in a panel, returning true if there were not any validation errors
 *
 * @param {Element} panel
 */
export const validatePanel = panel => {
  const inputs = [...getFields(panel)];
  return inputs.reduce((validity, input) => {
    return validateInput(input) && validity;
  }, true);
};
